import { styled } from '@mui/material/styles';
import { Grid, TableCell, TableContainer, TableRow, Typography, tableCellClasses } from '@mui/material';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#F4F4F4',
    color: theme.palette.common.black,
    fontFamily: "'Montserrat',sans-serif",
    fontWeight: 500,
    fontSize: 8,
    lineHeight: '12.19px',
    height: '34px',
    padding: '0 !important',
    align: 'center',
    border: '1px solid #E8E8E8',
  },
  [`&.${tableCellClasses.body}`]: {
    fontFamily: "'Montserrat',sans-serif",
    fontWeight: 400,
    fontSize: 8,
    lineHeight: '12.19px',
    height: '20.88px !important',
    padding: '0 !important',
  },
}));

export const StyledTableRow = styled(TableRow)(() => ({
  '&:nth-of-type(odd)': {
    backgroundColor: 'white',
  },
  '&:nth-of-type(even)': {
    backgroundColor: 'rgb(223, 32, 32, 4%)',
  },
  'td, th': {
    border: '1px solid #E8E8E8',
  },
  '&.selected': {
    color: '#FF0000',
  },
}));

export const StyledNARTDRow = styled(TableRow)(() => ({
  position: 'sticky',
  bottom: 0,
  zIndex: 3,
  backgroundColor: '#EEEDED',
  height: '20.88px',
  fontSize: 10,
  whiteSpace: 'nowrap',
  boxShadow: '0px -1px 3px rgba(0, 0, 0, 0.2)',
}));

export const StyledNARTDCell = styled(TableCell)(() => ({
  fontWeight: 700,
  whiteSpace: 'nowrap',
  textAlign: 'center',
}));

export const TableContainerSection = styled(TableContainer)(() => ({
  width: '623.66px',
  maxHeight: '190px',
  overflowY: 'auto',
  position: 'relative',
  borderRadius: '10px',
  overflowX: 'hidden',
  '&:hover': {
    overflow: 'auto',
    overflowX: 'hidden',
  },
}));

export const PerformanceTableSection = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '5px',
  marginTop: '15px',
}));

export const PerformanceTableTitle = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: 16,
  lineHeight: '19.15px',
}));

export const PerformanceTableNote = styled(Typography)(() => ({
  fontWeight: 400,
  fontStyle: 'italic',
  fontSize: '8.17px',
  lineHeight: '9.96px',
  color: '#84848C',
  justifyContent: 'flex-end',
  float: 'right',
  marginTop: '5px',
}));

export const PerformanceToggleSection = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
}));

export const PerformanceToggleTitle = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: 10,
  lineHeight: '12.17px',
}));
